export default "__VITE_ASSET__BbptC4Kr__"